import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getProceduresInProcedureBuilder } from '../utils/urls';

import { ProcedureBuilderListType } from 'types/procedureBuilder';
import { ErrorModal } from 'types/modalTypes';

async function fetchProcedureList({
  accountId,
}: TVariables): Promise<TResult & TError> {
  const response = await fetch(getProceduresInProcedureBuilder(accountId), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: Array<ProcedureBuilderListType>;
  IsSuccess: boolean;
  StatusCode: number;
};

type TVariables = {
  accountId: number;
};

function useGetProcedureBuilderProcedures(
  accountId?: number,
): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_procedure_builder_procedures', accountId],
    async () => {
      if (!accountId) return;
      const procedureList = await fetchProcedureList({
        accountId,
      });
      if (procedureList?.Errors) throw procedureList;
      return procedureList;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetProcedureBuilderProcedures };
